'use strict';

import GLightbox from 'glightbox'

const SELECTOR = '.js-video-modal';

function initialiseElement(element) {

    if (element === null) {
        return false;
    }

    new GLightbox({
        selector: SELECTOR,
        videosWidth: 1280
    });

}

export function init() {
    document.querySelectorAll(SELECTOR).forEach(initialiseElement);
}



// WEBPACK FOOTER //
// ./modules/videoModal.js